module.exports = __webpack_public_path__ + "img/PreviewCameraChecked.943badf1.png";